import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Label,
  FormFeedback,
  Button,
  Row,
  Col,
  Spinner,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import toast from "react-hot-toast";
import DiscountService from "../../../services/OrderingServices/DiscountService";
import ProductItemServices from "../../../services/OrderingServices/ProductItemService";
import CategoryServices from "../../../services/OrderingServices/CategoryService";
import { fetchDiscountAvailable } from "../../../slices/DiscountHandle/discountSlice";
import { useDispatch } from "react-redux";

const validationSchema = Yup.object({
  name: Yup.string().required("Discount name is required"),
  description: Yup.string().required("Description is required"),
  discountValue: Yup.number()
    .required("Discount value is required")
    .min(0, "Discount value must be at least 0"),
  discountType: Yup.number().required("Discount type is required"),
  discountTime: Yup.number().required("Discount time is required"),
  discountFor: Yup.number().required("Discount for is required"),
  startTime: Yup.string().required("Start time is required"),
  endTime: Yup.string().required("End time is required"),
  isActive: Yup.boolean().required(),
});

const formatDateTime = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = `${d.getMonth() + 1}`.padStart(2, "0");
  const day = `${d.getDate()}`.padStart(2, "0");
  const hours = `${d.getHours()}`.padStart(2, "0");
  const minutes = `${d.getMinutes()}`.padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const MobileDiscountForm = ({
  selectedDiscount,
  modal,
  toggleModal,
  fetchDiscounts,
}) => {
  console.log(
    "🚀 ~ selectedDiscount.discountFor:",
    selectedDiscount?.discountFor
  );

  console.log("🚀 ~ MobileDiscountForm ~ selectedDiscount:", selectedDiscount);
  const [loading, setLoading] = useState(false);
  const [productOptions, setProductOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const dispatch = useDispatch();
  const discountTypeOptions = [
    { value: 1, label: "Percentage" },
    { value: 2, label: "Fixed Amount" },
  ];
  const formatTime = (time) => (time ? `${time}:00` : "");

  const discountTimeOptions = [
    { value: 1, label: "Daily" },
    { value: 2, label: "Weekly" },
    { value: 3, label: "Monthly" },
    { value: 4, label: "Yearly" },
    { value: 5, label: "OneTime" },
  ];

  const discountForOptions = [
    { value: 1, label: "Category" },
    { value: 2, label: "Item" },
    { value: 3, label: "Entire Menu" },
  ];

  const mapDiscountType = (type) => {
    if (!type) return null;
    switch (type) {
      case "Percentage":
        return 1;
      case "FixedAmount":
      case "Fixed Amount":
        return 2;
      default:
        return null;
    }
  };

  const mapDiscountTime = (time) => {
    if (!time) return null;
    switch (time) {
      case "Daily":
        return 1;
      case "Weekly":
        return 2;
      case "Monthly":
        return 3;
      case "Yearly":
        return 4;
      case "OneTime":
        return 5;
      default:
        return null;
    }
  };

  const mapDiscountFor = (forValue) => {
    if (!forValue) return null;

    // Convert to lowercase for case-insensitive comparison
    const stringValue = String(forValue).toLowerCase();

    switch (stringValue) {
      case "category":
      case "categories":
        return 1;
      case "item":
      case "items": // <-- Add this line!
        return 2;
      case "entiremenu":
      case "entire menu":
        return 3;
      default:
        console.warn(`Unknown discountFor value: ${forValue}`);
        return null;
    }
  };
  console.log(
    "🚀 ~ mapped discountFor:",
    mapDiscountFor(selectedDiscount?.discountFor)
  );

  const formatTimeForInput = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const hours = `${d.getHours()}`.padStart(2, "0");
    const minutes = `${d.getMinutes()}`.padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const parseDiscountTime = (time) => {
    if (!time) return "";

    // If it's an object with ticks
    if (typeof time === "object" && "ticks" in time) {
      // .NET ticks (100-nanoseconds since 0001-01-01)
      const epochTicks = 621355968000000000; // ticks until 1970-01-01
      const ms = (time.ticks - epochTicks) / 10000; // convert ticks to milliseconds
      const d = new Date(ms);
      const hours = `${d.getHours()}`.padStart(2, "0");
      const minutes = `${d.getMinutes()}`.padStart(2, "0");
      return `${hours}:${minutes}`;
    }

    // If it's already a string or Date
    const d = new Date(time);
    if (isNaN(d)) return "";
    const hours = `${d.getHours()}`.padStart(2, "0");
    const minutes = `${d.getMinutes()}`.padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  // Fetch products & categories
  useEffect(() => {
    const fetchLists = async () => {
      try {
        const [productRes, categoryRes] = await Promise.all([
          ProductItemServices.getList({ pageNumber: 1, pageSize: 1000 }),
          CategoryServices.maincategory(),
        ]);

        const products =
          productRes?.items?.map((p) => ({ value: p.id, label: p.name })) || [];
        const categories =
          categoryRes?.items?.map((c) => ({ value: c.id, label: c.name })) ||
          [];

        setProductOptions(products);
        setCategoryOptions(categories);
      } catch (error) {
        console.error("Error fetching products/categories:", error);
      }
    };

    if (modal) fetchLists();
  }, [modal]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: selectedDiscount?.id || "",
      name: selectedDiscount?.name || "",
      description: selectedDiscount?.description || "",
      discountValue: selectedDiscount?.discountValue || "",
      discountType: mapDiscountType(selectedDiscount?.discountType),
      discountTime: mapDiscountTime(selectedDiscount?.discountTime),
      discountFor: mapDiscountFor(selectedDiscount?.discountFor),
      startTime: selectedDiscount?.startTime
        ? selectedDiscount.startTime.slice(0, 5)
        : "",
      endTime: selectedDiscount?.endTime
        ? selectedDiscount.endTime.slice(0, 5)
        : "",
      itemIds: [], // Start empty, let useEffect populate
      categoryIds: [], // Start empty, let useEffect populate
      isActive:
        selectedDiscount?.isActive === undefined
          ? true
          : selectedDiscount.isActive,
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      console.log("🚀 ~ MobileDiscountForm ~ values:", values);
      try {
        setLoading(true);

        // Ensure multi-selects have proper labels
        const itemIds = values.itemIds.map((i) => i.value);
        const categoryIds = values.categoryIds.map((c) => c.value);

        const today = new Date();
        const [startH, startM] = values.startTime.split(":");
        const [endH, endM] = values.endTime.split(":");

        const payload = {
          name: values.name,
          description: values.description,
          discountValue: values.discountValue,
          discountType: values.discountType,
          discountTime: values.discountTime,
          discountFor: values.discountFor,
          startTime: formatTime(values.startTime),
          endTime: formatTime(values.endTime),

          itemIds: values.itemIds.map((i) => i.value).join(","), // convert array to comma string
          categoryIds: values.categoryIds.map((c) => c.value).join(","), // convert array to comma string
          isActive: values.isActive,
        };

        if (values.id) {
          await DiscountService.update(values.id, payload);
          toast.success("Discount updated successfully.");
        } else {
          await DiscountService.create(payload);
          toast.success("New discount added successfully.");
          resetForm();
        }

        fetchDiscounts();
        await dispatch(fetchDiscountAvailable());

        toggleModal();
      } catch (error) {
        console.error(error);

        let errMsg = "Something went wrong";

        if (error?.response?.data) {
          const data = error.response.data;

          if (typeof data === "string") {
            errMsg = data;
          } else if (data.title) {
            errMsg = data.title;
          } else if (data.errors) {
            // flatten and join all error messages
            errMsg = Object.values(data.errors)
              .flat()
              .map((e) => (typeof e === "string" ? e : JSON.stringify(e)))
              .join(", ");
          } else {
            // fallback to stringify the object
            errMsg = JSON.stringify(data);
          }
        }

        toast.error(errMsg);
      } finally {
        setLoading(false);
      }
    },
  });

  // Reset form when modal closes
  useEffect(() => {
    if (!modal) formik.resetForm();
  }, [modal]);

  // Clear dependent fields when discountFor changes
  useEffect(() => {
    if (formik.values.discountFor === 1) formik.setFieldValue("itemIds", []);
    if (formik.values.discountFor === 2)
      formik.setFieldValue("categoryIds", []);
  }, [formik.values.discountFor]);

  // For categories
  useEffect(() => {
    if (selectedDiscount?.categoryIds && categoryOptions.length > 0) {
      const ids = selectedDiscount.categoryIds
        .split(",")
        .map((id) => Number(id.trim()));
      const mapped = categoryOptions.filter((c) => ids.includes(c.value));

      if (
        mapped.length > 0 &&
        JSON.stringify(formik.values.categoryIds) !== JSON.stringify(mapped)
      ) {
        formik.setFieldValue("categoryIds", mapped);
      }
    }
  }, [categoryOptions, selectedDiscount?.categoryIds]);

  // For items
  useEffect(() => {
    if (selectedDiscount?.itemIds && productOptions.length > 0) {
      const ids = Array.isArray(selectedDiscount.itemIds)
        ? selectedDiscount.itemIds
        : selectedDiscount.itemIds.split(",").map((id) => Number(id.trim()));

      const mapped = productOptions.filter((p) => ids.includes(p.value));

      if (
        mapped.length > 0 &&
        JSON.stringify(formik.values.itemIds) !== JSON.stringify(mapped)
      ) {
        formik.setFieldValue("itemIds", mapped);
      }
    }
  }, [productOptions, selectedDiscount?.itemIds]);

  console.log("Debug info:", {
    selectedDiscountItemIds: selectedDiscount?.itemIds,
    productOptions: productOptions.length,
    formikItemIds: formik.values.itemIds,
    discountFor: formik.values.discountFor,
  });
  return (
    <Offcanvas
      isOpen={modal}
      toggle={toggleModal}
      direction="end"
      backdropClassName="bg-dark bg-opacity-50"
      className="shadow-lg bg-white"
    >
      <OffcanvasHeader toggle={toggleModal}>
        <div className="d-flex align-items-center justify-content-center w-100 gap-2">
          {/* <i className="ri-percent-line"></i> */}
          <h5 className="mb-0">
            {selectedDiscount?.id ? "Edit Discount" : "Add Discount"}
          </h5>
        </div>
      </OffcanvasHeader>

      <Form onSubmit={formik.handleSubmit}>
        <OffcanvasBody style={{ maxHeight: "80vh", overflowY: "auto" }}>
          <Row>
            {/* Discount Name */}
            <Col lg={12}>
              <div className="form-floating mb-3">
                <Input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Enter discount name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={!!(formik.touched.name && formik.errors.name)}
                />
                <Label for="name">Discount Name</Label>
                <FormFeedback>{formik.errors.name}</FormFeedback>
              </div>
            </Col>

            {/* Discount Value */}
            <Col lg={12}>
              <div className="form-floating mb-3">
                <Input
                  id="discountValue"
                  name="discountValue"
                  type="number"
                  placeholder="Enter discount value"
                  value={formik.values.discountValue}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    !!(
                      formik.touched.discountValue &&
                      formik.errors.discountValue
                    )
                  }
                  min={0}
                />
                <Label for="discountValue">Discount Value</Label>
                <FormFeedback>{formik.errors.discountValue}</FormFeedback>
              </div>
            </Col>

            {/* Discount Type */}
            <Col lg={12}>
              <Label>Discount Type</Label>
              <Select
                options={discountTypeOptions}
                value={discountTypeOptions.find(
                  (opt) => opt.value === formik.values.discountType
                )}
                onChange={(opt) =>
                  formik.setFieldValue("discountType", opt?.value || null)
                }
                placeholder="Select discount type"
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {formik.touched.discountType && formik.errors.discountType && (
                <div className="text-danger mt-1">
                  {formik.errors.discountType}
                </div>
              )}
            </Col>

            {/* Discount Time */}
            <Col lg={12} className="mt-3">
              <Label>Discount Time</Label>
              <Select
                options={discountTimeOptions}
                value={discountTimeOptions.find(
                  (opt) => opt.value === formik.values.discountTime
                )}
                onChange={(opt) =>
                  formik.setFieldValue("discountTime", opt?.value || null)
                }
                placeholder="Select discount time"
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />

              {formik.touched.discountTime && formik.errors.discountTime && (
                <div className="text-danger mt-1">
                  {formik.errors.discountTime}
                </div>
              )}
            </Col>

            {/* Discount For */}
            <Col lg={12} className="mt-3">
              <Label>Discount For</Label>
              <Select
                options={discountForOptions}
                value={discountForOptions.find(
                  (opt) => opt.value === formik.values.discountFor
                )}
                onChange={(opt) =>
                  formik.setFieldValue("discountFor", opt?.value || null)
                }
                placeholder="Select discount for"
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            </Col>

            {/* Start & End Time */}
            <Col lg={12} className="mt-3">
              <div className="form-floating mb-3">
                <Input
                  id="startTime"
                  name="startTime"
                  type="time" // <-- changed from datetime-local to time
                  value={formik.values.startTime}
                  onChange={formik.handleChange}
                />
                <Label for="startTime">Start Time</Label>
              </div>
            </Col>

            <Col lg={12}>
              <div className="form-floating mb-3">
                <Input
                  id="endTime"
                  name="endTime"
                  type="time"
                  value={formik.values.endTime}
                  onChange={formik.handleChange}
                />
                <Label for="endTime">End Time</Label>
              </div>
            </Col>

            {/* Product Multi-select */}
            {formik.values.discountFor === 2 && (
              <Col lg={12}>
                <Label>Select Products</Label>
                <Select
                  isMulti
                  options={productOptions}
                  value={formik.values.itemIds}
                  onChange={(selected) =>
                    formik.setFieldValue("itemIds", selected || [])
                  }
                  placeholder="Select products"
                />
              </Col>
            )}

            {/* Category Multi-select */}
            {formik.values.discountFor === 1 && (
              <Col lg={12} className="mt-3">
                <Label>Select Categories</Label>
                <Select
                  isMulti
                  options={categoryOptions}
                  value={formik.values.categoryIds} // this should now be array of {value, label}
                  onChange={(selected) =>
                    formik.setFieldValue("categoryIds", selected || [])
                  }
                  placeholder="Select categories"
                />
              </Col>
            )}

            {/* Active Toggle */}
            <Col lg={12} className="mt-3">
              <div className="form-check form-switch">
                <Input
                  id="isActive"
                  name="isActive"
                  type="switch"
                  checked={formik.values.isActive}
                  onChange={(e) =>
                    formik.setFieldValue("isActive", e.target.checked)
                  }
                />
                <Label for="isActive" check>
                  Active
                </Label>
              </div>
            </Col>

            {/* Description */}
            <Col lg={12}>
              <div className=" mb-3">
                <Label for="description">Description</Label>

                <Input
                  id="description"
                  name="description"
                  type="textarea"
                  rows={6}
                  placeholder="Enter description"
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    !!(formik.touched.description && formik.errors.description)
                  }
                />
                <FormFeedback>{formik.errors.description}</FormFeedback>
              </div>
            </Col>
          </Row>
        </OffcanvasBody>

        <div className="p-3 position-sticky bottom-0 bg-white border-top">
          <div className="d-flex gap-2">
            <Button color="danger" onClick={toggleModal} className="w-100">
              Cancel
            </Button>
            <Button
              color="success"
              type="submit"
              disabled={loading}
              className="w-100"
            >
              {loading && <Spinner size="sm" className="me-2" />}
              {selectedDiscount?.id ? "Update" : "Create"}
            </Button>
          </div>
        </div>
      </Form>
    </Offcanvas>
  );
};

export default MobileDiscountForm;
